import { PackagesService } from './../../../packages/services/packages.service';
import { Directionality } from '@angular/cdk/bidi';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  LangService,
  language,
  ModalService,
  Roles,
  SecurityCompany,
} from 'projects/tools/src/public-api';
import { ACCOUNT_LIST } from '../../../account-management/routes/account-routes.enum';
import { AuthService } from '../../../auth/services/auth.service';
import { SIDEBAR_LIST } from '../../data/sidebar-menu';
import { MenuItem } from '../../models/menu-item';
import { Routing } from '../../routes/app-routes';
import { CompanyProfileService } from '../../../jobs/services/company-profile.service';
import { NotifyService } from '../../services/notify.service';
import { notify } from '../../models/notify';
import { Loader } from '../../enums/loader.enum';
import { HubConnection, HubConnectionBuilder, IHttpConnectionOptions } from '@microsoft/signalr';
import { environment } from 'projects/security-company-dashboard/src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
})
export class DashboardLayoutComponent implements OnInit {
  private _hubConnection!: HubConnection;
  numberOfSuperVisors!: number;
  modalId3 = 'modalId3';
  sum = 10;
  throttle = 1000;
  scrollDistance = 1;
  scrollUpDistance = 100;
  direction = '';
  modalOpen = false;
  temp!: notify[];
  start: number = 1;
  AllNotify: any[] = [];
  total: number = 0;
  date: any;
  packages!: boolean;
  img: any;
  menu: MenuItem[] = [...SIDEBAR_LIST];
  step!: number;
  accountList: { name: string; link: string; icon: string }[] = [
    ...ACCOUNT_LIST,
  ];
  userInfo!: SecurityCompany;
  routing = Routing;
  isOpen: boolean = false;
  technicalSupport!: number;
  /** Whether the widget is in RTL mode or not. */
  private isRtl!: boolean;
 totalUnreadNotifications!:any;
  /** Subscription to the Directionality change EventEmitter. */
  private _dirChangeSubscription = Subscription.EMPTY;
  private readonly url = environment.api;
totalCount!:any;
  constructor(
    public lang: LangService,
    public auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private profileComplete: CompanyProfileService,
    private PackagesService: PackagesService,
    private modal: ModalService,
    private notify: NotifyService,
    private http: HttpClient,
  ) {
    this.getInitData();
    //this.connectHub();
    this. getNumbersOfUnreadNotifications();
  }

  ngOnInit(): void {
    this.auth.packages.subscribe((res) => {
      this.packages = res;
    });
    this.profileComplete.stepNumber.subscribe((res) => {
      this.step = res;
    });
  }

  getInitData() {
  
   console.log(this.auth.snapshot.userIdentity?.roles);
   if(this.auth.snapshot.userIdentity?.roles.includes('CLIENTVISITORUSER')) {
    this.http.get(this.url+`api/ClientVisitorUser/Get?Id=${this.auth.snapshot.userIdentity?.UserId}`).subscribe((res:any)=>{
      console.log(res);
      
      if(res){
      this.http.get(this.url+`api/SecurityCompany/GetById?id=${res.securityCompanyId}`).subscribe((response:any)=>{
           this.userInfo=response
      })
      }
    })
   }else{
     this.auth.getSecurityCompany().subscribe((res)=>{
      this.userInfo=res;
     })
   }
   // this.userInfo = this.route.snapshot.data['company'];
    console.log(this.userInfo);
    
    if (this.userInfo) {
      if (!this.userInfo.isActive) {
        if (this.userInfo?.isRejected) {
          this.router.navigate(['/' + Routing.rejected]);
        } else if (this.userInfo.isApproved) {
          this.router.navigate(['/' + Routing.approved]);
        } else {
          this.router.navigate(['/' + Routing.pending]);
        }
      }
    }

    if (this.auth.snapshot.userIdentity?.role == Roles.SecurityCompanyUser) {
      if (
        !this.userInfo.appUser.isActive ||
        !this.userInfo.securityCompanyBranch.stauts
      ) {
        this.router.navigate(['/' + Routing.notActive]);
      }
    }
  }

  onLanguageChange() {
    this.lang.toggleLanguage();
  }

  modified(statment:string): string | any {
    if(statment.match(/[\u0660-\u0669]+\/[\u0660-\u0669]+\/[\u0660-\u0669]+/g)){
      let modifiedStatement = statment.replace(/[\u0660-\u0669]+\/[\u0660-\u0669]+\/[\u0660-\u0669]+/g, '');
      console.log(modifiedStatement);
     return modifiedStatement;
  }else{
    //console.log(statment);
    
    return statment;
  }
  }

  logout() {
    this.auth.logout();
  }
  // connectHub() {
  //   let token = this.auth.snapshot.userIdentity?.token
  //   const options: IHttpConnectionOptions = {
  //     accessTokenFactory: () => {
  //       // Handle the case where token is null or undefined
  //       if (token === null || token === undefined) {
  //         return ''; // or another default value
  //       }
    
  //       return Promise.resolve(token);
  //     }
  //   };
  //   this._hubConnection = new HubConnectionBuilder()
  //     .withUrl(environment.hub , options)
  //     .build();

  //   this._hubConnection
  //     .start()
  //     .then(() => {
  //       this._hubConnection.invoke(
  //         'AddToGroup',
  //         `${this.auth.snapshot.userInfo?.id}-attendance`
  //       );
  //       console.log("start");
        
  //       this._hubConnection.on('ReceiveMessage', (x, y) => {
  //         console.log("notifications signalR");
          
  //         this.getNumbersOfUnreadNotifications();
  //       });
  //     })
  //     .catch((err) =>
  //       console.log('error while establishing signalr connection')
  //     );
  // }

  getNumbersOfUnreadNotifications(){
    this.notificationCount()
     setInterval(() => {
      this.notificationCount();
    }, 100000);
  }

 notificationCount(){
  if (this.auth.snapshot.userIdentity?.role == Roles.SecuritCompany) {
    if (this.auth.snapshot.userInfo?.id) {
      const id = this.auth.snapshot.userInfo?.id
  //console.log(this.auth.snapshot.userInfo);
this.notify.GetAllForSecurityCompanyCount(id).subscribe((res)=>{
this.totalCount=res;
this.totalUnreadNotifications=this.nFormatter(res);
console.log(this.totalUnreadNotifications);
})
    }
  } else if (this.auth.snapshot.userIdentity?.role == Roles.SecurityCompanyUser){
    if (this.auth.snapshot.userInfo?.securityCompanyBranch.id) {
     const id = this.auth.snapshot.userInfo.securityCompanyBranch.id;
     //console.log(this.auth.snapshot.userInfo);
     this.notify.GetAllForSecurityCompanyBranchCount(id).subscribe((res)=>{
      this.totalCount=res;
      this.totalUnreadNotifications=this.nFormatter(res);
        console.log(this.totalUnreadNotifications);
     })
    }
  
  }
 } 

 nFormatter(num: any) {
  if (num >= 1000000000) {
      return Math.floor(num / 1000000000) + 'G';
  }
  if (num >= 1000000) {
      return Math.floor(num / 1000000) + 'M';
  }
  if (num >= 1000) {
      return Math.floor(num / 1000) + 'K';
  }
  return num;
}

  displayNotify() {
    this.AllNotify=[];
    if (this.auth.snapshot.userIdentity?.role == Roles.SecuritCompany) {
      this.companyNotify();
    } else {
      this.companyBranchNotify();
    }
  }
  companyNotify() {
    let id!: number;
    if (this.auth.snapshot.userInfo?.id) {
      id = this.auth.snapshot.userInfo.id;
    }
    this.notify
      .companyNotification(id, this.start, 10 ,Loader.no)
      .subscribe((response: any) => {
        if (response) {
          this.hideloader();
          this.getNumbersOfUnreadNotifications();
        }
        this.temp = response.data; //1
        this.total = response.totalCount;
  
        this.addphotos(this.start, this.sum); // 2
   
      });
  }

  companyBranchNotify() {
    let id!: string;
    if (this.auth.snapshot.userInfo?.securityCompanyBranch.id) {
      id = this.auth.snapshot.userInfo.securityCompanyBranch.id;
    }
    this.notify
      .companyBranchNotification(id, this.start, 10 ,Loader.no)
      .subscribe((response: any) => {
        if (response) {
          this.hideloader();
          this.getNumbersOfUnreadNotifications();
        }
        this.temp = response.data; //1
        this.total = response.totalCount;
        this.addphotos(this.start, this.sum); // 2
      });
  }

  addphotos(index: number, sum: number) {
    for (let i = 0; i < sum; i++) {
      if (this.temp[i] != null) {
        this.AllNotify.push(this.temp[i]);
      }
    }
  }

  onScrollDown() {
    this.start = this.start + 1;
    if (this.auth.snapshot.userIdentity?.role == Roles.SecuritCompany) {
      this.companyNotify();
    } else {
      this.companyBranchNotify();
    }
    this.direction = 'down';
  }

  hideloader() {
    document.getElementById('loading')!.style.display = 'none';
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this._dirChangeSubscription.unsubscribe();
  }
  support() {
    this.technicalSupport =
      this.PackagesService.myPackage.getValue().technicalSupport;
    this.modal.open(this.modalId3);
  }

  redirect(){
    this.router.navigate(['/dashboard/settings/notifications']);
  }
}
